<template>
  <li
    v-if="canViewVerticalNavMenuGroup(item)"
    class="nav-item has-sub"
    :class="{
      open: isOpen,
      disabled: item.disabled,
      'sidebar-group-active': isActive,
      'nav-item--report-locked': isNavReportLocked,
    }"
  >
    <!-- Trava de report pendente: grupo sem "Compromissos" fica fechado, com cadeado no lugar da seta -->
    <b-link
      class="d-flex align-items-center link-group"
      :disabled="isNavReportLocked"
      :title="navReportLockedHint"
      @click="() => (isOpen = !isOpen)"
      style="
        background-color: transparent !important;
        margin-top: 1.55rem;
        padding: 12px 15px 0px 15px;
      "
    >
      <feather-icon :icon="item.icon || 'CircleIcon'" />
      <span class="menu-title text-truncate">{{ t(item.title) }}</span>
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
      <transition name="nav-report-lock">
        <feather-icon
          v-if="isNavReportLocked"
          icon="LockIcon"
          size="14"
          class="nav-report-lock-icon nav-report-lock-icon--group"
          aria-hidden="true"
        />
      </transition>
    </b-link>
    <b-collapse v-model="isOpen" class="menu-content" tag="ul">
      <component
        :is="resolveNavItemComponent(child)"
        v-for="child in item.children"
        :key="child.menuKey || child.header || child.title"
        ref="groupChild"
        :item="child"
      />
    </b-collapse>
  </li>
</template>

<script>
import { BLink, BBadge, BCollapse } from "bootstrap-vue";
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from "@core/layouts/utils";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import { useUtils as useAclUtils } from "@core/libs/acl";
import VerticalNavMenuHeader from "../vertical-nav-menu-header";
import VerticalNavMenuLink from "../vertical-nav-menu-link/VerticalNavMenuLink.vue";

// Composition Function
import useVerticalNavMenuGroup from "./useVerticalNavMenuGroup";
import mixinVerticalNavMenuGroup from "./mixinVerticalNavMenuGroup";
import mixinReportLockedNavItem from '../../mixinReportLockedNavItem'

export default {
  name: "VerticalNavMenuGroup",
  components: {
    VerticalNavMenuHeader,
    VerticalNavMenuLink,
    BLink,
    BBadge,
    BCollapse,
  },
  mixins: [mixinVerticalNavMenuGroup, mixinReportLockedNavItem],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  watch: {
    // Travou com o grupo aberto: fecha (os itens dele não navegam). Ao liberar, nada muda aqui.
    isNavReportLocked(locked) {
      if (locked) this.isOpen = false
    },
  },
  setup(props) {
    const { isActive, updateGroupOpen, updateIsActive, isOpen } =
      useVerticalNavMenuGroup(props.item);

    const { t } = useI18nUtils();
    const { canViewVerticalNavMenuGroup } = useAclUtils();

    return {
      resolveNavItemComponent,
      isActive,
      updateGroupOpen,
      updateIsActive,
      isOpen,

      // ACL
      canViewVerticalNavMenuGroup,

      // i18n
      t,
    };
  },
};
</script>

<style lang="scss" scoped>
.link-group {
  text-transform: uppercase;
  font-size: 0.9rem;
  font-weight: bold;
}
</style>
